import { Input } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";

import { GenesysFormItemKeys } from "../constants";

import sharedStyles from "../SharedDemoStyles.module.scss";

const REQUIRED_NAME_RULE = generateFormItemRequiredRules("Genesys selection");
const REQUIRED_ID_RULE = generateFormItemRequiredRules("Campaign Id");
const NAME_LABEL = "Campaign Name";
const ID_LABEL = "Genesys Campaign";
const ID_PLACEHOLDER = "Genesys Campaign Id";

export function GenesysFormItems(): JSX.Element {
    return (
        <>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                showFormLabel
                name={GenesysFormItemKeys.genesysName}
                label={NAME_LABEL}
                rules={REQUIRED_NAME_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                name={GenesysFormItemKeys.genesysID}
                label={ID_LABEL}
                placeholder={ID_PLACEHOLDER}
                showFormLabel
                rules={REQUIRED_ID_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
        </>
    );
}
